var _rect, _g, _circle, _text, _text2, _text3, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKcCoopPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 200",
    width: 350,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 200,
    rx: 24,
    fill: "#2c2c6c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4db5ff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 110,
    height: 70,
    rx: 10,
    fill: "rgba(77,181,255,0.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 110,
    height: 70,
    rx: 10,
    fill: "rgba(77,181,255,0.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 110,
    height: 70,
    rx: 10,
    fill: "#1f1f38"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 60,
    x2: 140,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 76,
    x2: 164,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 92,
    x2: 120,
    y2: 92
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 40,
    r: 18,
    fill: "#4db5ff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 47,
    textAnchor: "middle",
    fontFamily: "Poppins, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#1f1f38"
  }, "+")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 120,
    fontFamily: "Poppins, sans-serif",
    fontSize: 26,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Coop+")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 142,
    fontFamily: "Poppins, sans-serif",
    fontSize: 12,
    fill: "rgba(255,255,255,0.6)"
  }, "Subscription Platform")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 160,
    fontFamily: "Poppins, sans-serif",
    fontSize: 12,
    fill: "rgba(255,255,255,0.6)"
  }, "Knowledge Coop")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcCoopPlus);
export default __webpack_public_path__ + "static/media/KcCoopPlus.712db08753d80cc23b78224cc3b64cb0.svg";
export { ForwardRef as ReactComponent };